module.exports = __webpack_public_path__ + "img/stamp-event.1323236c.png";